import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePermissions } from '../../shared/providers/PermissionContext';
import {
  HITOWA_RBAC_SETTINGS_PATH,
  canAccessRbacSettings,
} from '../rbac-settings/access';

/**
 * HITOWA's unified landing page intentionally avoids legacy clinic-only
 * dashboard requests. Admin, ClinicUser and Massager principals all share this
 * shell; each protected business screen performs its own permission + scope
 * checks when opened.
 */
const RahDashboardPage: React.FC = () => {
  const { tenant = '' } = useParams<{ tenant: string }>();
  const permission = usePermissions();
  const settingsVisible = canAccessRbacSettings(permission);

  return (
    <main className="rah-unified-dashboard" data-testid="hitowa-unified-dashboard">
      <section className="rounded border border-slate-200 bg-white p-6">
        <p className="mb-2 text-xs font-semibold tracking-wider text-slate-500">HITOWA UNIFIED PORTAL</p>
        <h1 className="mb-3 text-2xl font-semibold text-slate-900">RAH ダッシュボード</h1>
        <p className="m-0 text-sm leading-6 text-slate-600">
          ロールと権限グループに基づいて、利用できる機能だけが表示されます。
        </p>
        {settingsVisible && (
          <Link
            className="mt-5 inline-flex rounded bg-slate-800 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700"
            to={`/${tenant}${HITOWA_RBAC_SETTINGS_PATH}`}
          >
            権限設定を開く
          </Link>
        )}
      </section>
    </main>
  );
};

export default RahDashboardPage;
